import React from 'react';
import Status from '../../../../../components/Status';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import {
    STATUS_COLORS,
    STATUS_KEYS,
} from '../../../utils/zitoneoServicesUtils';

const StatusIndicator = ({ isLoading }: { isLoading: boolean }) => {
    const { ZitoneoPublishStatus, ZitoneoPublishStatusKey } =
        useZitoneoServices();

    if (ZitoneoPublishStatusKey === STATUS_KEYS.NOT_STARTED) {
        return null;
    }

    return (
        <div className='flex flex-align-center gap-20'>
            {!isLoading && (
                <Status
                    text={ZitoneoPublishStatus}
                    color={
                        STATUS_COLORS[
                            ZitoneoPublishStatusKey as keyof typeof STATUS_COLORS
                        ]
                    }
                />
            )}
        </div>
    );
};

export default StatusIndicator;
